



































































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { HistoricoResposta } from '../../../../back/src/entity/HistoricoResposta';
import { HistoricoPergunta } from '../../../../back/src/entity/HistoricoPergunta';
import { HistoricoRespostaFormData } from '../../../../back/src/types';

import Confirmar from '../Confirmar.vue';

export default Vue.extend({
  name: 'TheHistoricoRespostaPergunta',
  components: {
    Confirmar,
  },
  props: {
    index: {
      type: Number,
    },
    resposta: {
      type: Object as () => HistoricoResposta,
    },
    saveButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        id: this.resposta.id,
        resposta: this.resposta.resposta,
        observacoes: this.resposta.observacoes,
      },
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    pergunta(): HistoricoPergunta {
      return this.resposta.historico_pergunta;
    },
    perguntaInfo(): boolean {
      if (this.pergunta.opcoes !== null && _.has(this.pergunta.opcoes, '0')) {
        if (this.pergunta.opcoes['0'] !== 'Sim') {
          return true;
        }
        return false;
      }
      return true;
    },
    color(): string {
      if (this.perguntaInfo) {
        if (this.form.resposta === null) {
          return 'warning';
        }
        return 'info';
      }
      if (this.form.resposta === '0') {
        return 'info';
      }
      if (this.form.resposta === '1') {
        return 'grey';
      }
      if (this.form.resposta === '2') {
        return 'secondary';
      }
      return 'warning';
    },
    textColor(): string {
      if (this.perguntaInfo) {
        if (this.form.resposta === null) {
          return 'warning--text';
        }
        return 'info--text';
      }
      if (this.form.resposta === '0') {
        return 'info--text';
      }
      if (this.form.resposta === '1') {
        return 'grey--text';
      }
      if (this.form.resposta === '2') {
        return 'secondary--text';
      }
      return 'warning--text';
    },
  },
  mounted() {
    const respostaStore = _.find(
      this.$store.getters.historicoRespostaFormData as HistoricoRespostaFormData[],
      el => (el.id === this.resposta.id),
    );
    if (respostaStore) {
      this.form.resposta = respostaStore.resposta;
      this.form.observacoes = respostaStore.observacoes;
      this.submitForm();
    }
  },
  methods: {
    // eslint-disable-next-line func-names
    desfazerDebounce: _.debounce(async function () { await this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('desfazer');
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      const formData: HistoricoRespostaFormData = {
        id: this.form.id,
        historico_id: this.resposta.historico_id,
        historico_pergunta_id: this.resposta.historico_pergunta_id,
        resposta: this.form.resposta,
        observacoes: this.form.observacoes,
      };
      try {
        const response = await Requester.historico.historicosRespostas([formData]);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$store.dispatch('pushHistoricoRespostaFormData', formData);
        } else {
          if (this.saveButton) {
            this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Histórico atualizado com sucesso!' });
          }
          this.$emit('respostaAtualizada', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
        this.$store.dispatch('pushHistoricoRespostaFormData', formData);
      } finally {
        this.loading = false;
      }
    },
  },
});
